import { selectCarLocation,selectByCarRealTimeStatus,getCarRealTimeStatus,getDriverSwipingCardSituation,selectOneCar,selectOneDriver,selectOneTerminal,getCarOperationList } from "../../api/config/modules/VehicleStatus";

const state = {
    selectByCarRealTimeStatus: {},
    getCarRealTimeStatus: {},
    getDriverSwipingCardSituation: {},
    selectOneCar: {},
    selectOneDriver: {},
    selectOneTerminal: {},
    selectCarLocation: {},
    getCarOperationList: {}
};

const mutations = {
  SET_REALTIMESTATUS: (state, selectByCarRealTimeStatus) => {
    state.selectByCarRealTimeStatus = selectByCarRealTimeStatus;
  },
  SET_CARREALTIMESTATUS: (state, getCarRealTimeStatus) => {
    state.getCarRealTimeStatus = getCarRealTimeStatus;
  },
  SET_DRIVERSWIPINGCARD: (state, getDriverSwipingCardSituation) => {
    state.getDriverSwipingCardSituation = getDriverSwipingCardSituation;
  },
  SET_SELECTONECAR: (state, selectOneCar) => {
    state.selectOneCar = selectOneCar;
  },
  SET_SELECTONEDRIVER: (state, selectOneDriver) => {
    state.selectOneDriver = selectOneDriver;
  },
  SET_SELECTONETERMINAL: (state, selectOneTerminal) => {
    state.selectOneTerminal = selectOneTerminal;
  },
  SET_SELECTCARLOCATION: (state, selectCarLocation) => {
    state.selectCarLocation = selectCarLocation;
  },
  SET_GETCAROPERATIONLIST: (state, getCarOperationList) => {
    state.getCarOperationList = getCarOperationList;
  },
};

const actions = {
  GET_REALTIMESTATUS: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        selectByCarRealTimeStatus(data)
        .then((res) => {
          commit("SET_REALTIMESTATUS", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_CARREALTIMESTATUS: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        getCarRealTimeStatus(data)
        .then((res) => {
          commit("SET_CARREALTIMESTATUS", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DRIVERSWIPINGCARD: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        getDriverSwipingCardSituation(data)
        .then((res) => {
          commit("SET_DRIVERSWIPINGCARD", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTONECAR: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        selectOneCar(data)
        .then((res) => {
          commit("SET_SELECTONECAR", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTONEDRIVER: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        selectOneDriver(data)
        .then((res) => {
          commit("SET_SELECTONEDRIVER", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTONETERMINAL: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        selectOneTerminal(data)
        .then((res) => {
          commit("SET_SELECTONETERMINAL", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTCARLOCATION: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectCarLocation(data)
        .then((res) => {
          commit("SET_SELECTCARLOCATION", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETCAROPERATIONLIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      getCarOperationList(data)
        .then((res) => {
          commit("SET_GETCAROPERATIONLIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
